import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { T } from 'containers';

const placeholderColor = '#c3ced9';

const StyledInput = styled.input`
  border: 0;
  outline: none;
  display: block;
  margin: 0;
  width: calc(100% - 40px);
  line-height: 17px;

  ${({ valid }) => (typeof valid === 'boolean' && valid === false) ? 'color: #f00;' : ''}

  &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: ${placeholderColor};
    font-weight: normal;
  }
  &::-moz-placeholder { /* Firefox 19+ */
    color: ${placeholderColor};
    font-weight: normal;
  }
  &:-ms-input-placeholder { /* IE 10+ */
    color: ${placeholderColor};
    font-weight: normal;
  }
  &:-moz-placeholder { /* Firefox 18- */
    color: ${placeholderColor};
    font-weight: normal;
  }
  &::placeholder {
    color: ${placeholderColor};
    font-weight: normal;
  }
`;

class BirthdayInput extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string, // YYYY-MM-DD || MM/DD/YYYY || DD/MM/YY || MM.DD.YYYY
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    valid: PropTypes.bool,
    readOnly: PropTypes.bool,
    type: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    appText: PropTypes.string,
    maxValue: PropTypes.number,
  };
  static defaultProps = {
    type: 'text',
    value: '',
    onChange: () => {},
    onBlur: () => {},
    onMove: () => {},
    maxValue: Number.MAX_SAFE_INTEGER / 2,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  componentWillReceiveProps({ value }) {
    this.setState({
      value,
    });
  }

  onChange = (event) => {
    const { value: currentValue } = this.state;

    const value = event.target.value.replace(/[^0-9]/g, '');
    if (value !== currentValue) {
      this.setState({ value });
      this.props.onChange(value);
    }
  }

  onKeyDown = (event) => {
    const { readOnly, maxValue, onChange } = this.props;
    const { value } = this.state;

    if (readOnly) return;
    const curValue = parseInt(value, 10) || 0;
    let theValue = 0;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        theValue = curValue - 1;
        break;
      case 'ArrowUp':
        event.preventDefault();
        theValue = curValue + 1;
        break;
      default:
        return;
    }
    theValue = Math.max(1, Math.min(theValue, maxValue));

    onChange(`${(theValue < 10 && theValue > 0) ? '0' : ''}${theValue}`);
  }

  render() {
    const { value } = this.state;
    const { className, onFocus, onBlur, placeholder, valid, type, title, readOnly, appText, id } = this.props;

    return (
      <T
        text={[
          appText,
        ]}
        render={([
          appTextTranslation,
        ]) => (
          <div className={`column ${className}`}>
            <label htmlFor={id}>{appTextTranslation}</label>
            <StyledInput
              onChange={this.onChange}
              onKeyDown={this.onKeyDown}
              {...{
                id,
                type,
                placeholder,
                value,
                onFocus,
                onBlur,
                readOnly,
                valid,
                title,
              }}
            />
          </div>
        )}
      />
    );
  }
}

export default BirthdayInput;



// WEBPACK FOOTER //
// ./src/components/molecules/GuestBirthdayInput/Input.js